var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"__header"},[_vm._t("leading"),_vm._t("default"),_vm._t("trailing")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }